import React from 'react';
import { Outlet, useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// This component is responsible for protecting routes.
const ProtectedRoute = ({ allowedRoles }) => {
  const navigate = useNavigate();
  const { userRole, currentUser } = useAuth();

  // If there's no user logged in, redirect to login page
  if (!currentUser) {
    return <Navigate to="/" />;
  }

  // Check if user's role is included in the allowed roles for this route
  if (!allowedRoles.includes(userRole)) {
    // If user is not allowed, navigate to the appropriate route based on their role
    if (userRole === 'superadmin' || userRole === 'setCastEditor') {
      return <Navigate to="/admin" />;
    } else if (userRole === 'clientService' || userRole === 'editor' || userRole === 'planning') {
      return <Navigate to="/cs" />;
    } else if (userRole === 'talent') {
      return <Navigate to="/talent/" />;
    } else {
      return <Navigate to="/np/" />;
    }
  }

  // If user is allowed, render the component for this route
  return <Outlet />;
};

export default ProtectedRoute;
